module.exports = __webpack_public_path__ + "static/media/doug with arms2-4.bce922a0.jpg";